












export default

	computed:

		# Get the count of items in the cart
		cartQty: -> @$store.getters['cart/itemCount']

	methods:

		openCart: -> @$store.commit 'cart/open'

